import { Attributes, Misc, NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ProcessStatusSearchCriteria extends ValueObject {
    
    public staticServiceProviderFileGroupingID: number | null = null;

    public serviceProviderGroupingName: string | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public date: Date | null = null;
}